import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Nav, Navbar, NavDropdown, Dropdown } from 'react-bootstrap';
import classNames from 'classnames';
import { Link, useLocation } from 'react-router-dom';
import _ from 'lodash';
import routes from 'src/navigation/routes';
import { faExclamationTriangle, faBell } from '@fortawesome/free-solid-svg-icons';
import styles from './assets/top-menu.module.scss';
import user from 'src/services/user-auth';
import { StoreState } from '../../../store/reducers';
import { getUnconfirmedSeances } from '../../../store/actions/seance-actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { QueryParams } from '../../../types/grid';
import { selectGroupUnconfirmed } from 'src/store/selectors/seance-selectors';
import Router from '../../../navigation/router';
import UserRole from '../../../enumerables/user-role';
import logoText from '../../../assets/images/logoText.png';
import logoMobile from '../../../assets/images/logo-m.png';
import { IAgencyInfo } from '../../../types/app';
import GeneralEnum from '../../../enumerables/general-enum';
import LeftMenu from '../LeftMenu/LeftMenu';
import { Paginated } from '../../../services/api-handlers/pagination';
import { IInvoiceDoc } from '../../../types/invoice';

export interface StateProps {
    authorized: boolean;
    agencyInfo: IAgencyInfo | null;
    dataDocs: Paginated<IInvoiceDoc>;
    unconfirmed: {
        data: {
            [key: string]: { list: { text: string; id: string }[]; title: string; provider: string; occasion: string };
        };
        lengthUnc: number;
    };
}

export interface DispatchProps {
    getUnconfirmedSeances: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

const TopMenu: React.FC<Props> = ({ authorized, unconfirmed, getUnconfirmedSeances, agencyInfo, dataDocs }: Props) => {
    const location = useLocation();

    let userName: string | null = null;
    if (authorized) {
        userName = user.getUsername();
    }
    const [isOpen, setOpen] = useState(false);
    useEffect(() => {
        //  if () {   }
        // eslint-disable-next-line
        const isSupervisor = user.getSupervisor();
        user.getRoles().includes(UserRole.ROLE_USER) && !isSupervisor && getUnconfirmedSeances({ page: 1 });

        // eslint-disable-next-line
    }, []);
    const logoItem = GeneralEnum.getEnum('logoDoc');

    //const isAdmin = securityService.isGranted(UserRole.ROLE_ADMIN, null);
    const isMobile = window.innerWidth <= 800;
    return (
        <div className={classNames(styles.topMenuWrap)}>
            <Nav className={classNames(styles.topMenu, 'mr-auto')}>
                <Navbar expanded={isOpen} className={classNames(styles.navBar)} onToggle={setOpen} expand="xl">
                    <strong className={classNames(styles.headerLogo)}>
                        {logoItem && logoItem.length ? (
                            <Link to={'/'} className={classNames(styles.logoWrap)}>
                                <img
                                    src={logoItem}
                                    className={classNames(styles.headerLogoImg)}
                                    alt="Manhattan Psychology Group"
                                />

                                <img
                                    src={logoMobile}
                                    className={classNames(styles.headerLogoImgM)}
                                    alt="Manhattan Psychology Group"
                                />
                            </Link>
                        ) : (
                            <Link to={'/'} className={classNames(styles.logoWrap)}>
                                <img
                                    src={logoMobile}
                                    className={classNames(styles.headerLogoImg)}
                                    alt="Manhattan Psychology Group"
                                />
                                <img
                                    src={logoText}
                                    className={classNames(styles.headerLogoImg)}
                                    alt="Manhattan Psychology Group"
                                />
                                <img
                                    src={logoMobile}
                                    className={classNames(styles.headerLogoImgM)}
                                    alt="Manhattan Psychology Group"
                                />
                            </Link>
                        )}
                    </strong>

                    <React.Fragment>
                        <div className={classNames(styles.menuToggleWrapper)}>
                            {!!dataDocs.list.length &&
                            user.getRoles().includes(UserRole.ROLE_ADMIN) &&
                            isMobile &&
                            location.pathname !== '/invoice-docs/list' ? (
                                <Link
                                    className={` text-white ${classNames(styles.btnPending)}`}
                                    to={Router.generate(routes.INVOICE_DOCS_LIST)}
                                >
                                    Pending <FontAwesomeIcon className={'ml-1'} icon={faBell} />
                                    <span className={'ml-1'}>({dataDocs.list.length})</span>
                                </Link>
                            ) : null}
                            {!_.isEmpty(unconfirmed.data) ? (
                                <Dropdown className={classNames(styles.topMenuDropdown)}>
                                    <Dropdown.Toggle
                                        className={`btn btn-warning text-white ${classNames(styles.caseItem)}`}
                                        variant="warning"
                                        id="dropdown-basic"
                                    >
                                        <b
                                            style={{ position: 'relative', top: '-1px' }}
                                        >{`(${unconfirmed.lengthUnc})`}</b>{' '}
                                        Unconfirmed
                                        <FontAwesomeIcon className={'ml-1'} icon={faExclamationTriangle} />
                                    </Dropdown.Toggle>

                                    <Dropdown.Menu
                                        style={{ transition: 'all 0.3s ease 0s' }}
                                        className={'p-0 unconfirmed-items'}
                                    >
                                        {_.map(unconfirmed.data, (it, k) => (
                                            <div key={`${k}-k`}>
                                                <div className={classNames(styles.menuItem)}>{it.title}</div>
                                                <div className={styles.menuItems}>
                                                    {it.list.map((seance, k) => (
                                                        <div
                                                            key={`${k}-seance`}
                                                            className={classNames(
                                                                styles.menuItemWrap,
                                                                'text-white  p-1 pl-4',
                                                            )}
                                                        >
                                                            <Link
                                                                target="_blank"
                                                                className={classNames(
                                                                    styles.menuItemLink,
                                                                    styles.menuItem,
                                                                    'text-white',
                                                                )}
                                                                to={Router.generate(routes.PROVIDER_DETAIL, {
                                                                    tab: 'case-sessions-edit',
                                                                    id: it.provider,
                                                                    subId: `${seance.id}`,
                                                                })}
                                                            >
                                                                {`${seance.text}`}
                                                            </Link>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            ) : null}
                            <Navbar.Toggle
                                onClick={() => setOpen(!isOpen)}
                                aria-controls="basic-navbar-nav"
                                className={classNames(styles.menuToggle)}
                            />
                        </div>

                        <Navbar.Collapse id={'basic-navbar-nav'} className={classNames(styles.sidebar)}>
                            <LeftMenu
                                setOpen={() => {
                                    setOpen(false);
                                }}
                                pendingLength={dataDocs.list.length}
                            />

                            {userName ? (
                                <NavDropdown
                                    className={classNames(styles.title, styles.NavDropdown, 'text-white')}
                                    title={userName}
                                    id="basic-nav-dropdown"
                                >
                                    <Link
                                        to={{
                                            pathname: routes.LOGOUT,
                                            state: {},
                                        }}
                                        className="dropdown-item"
                                    >
                                        Logout
                                    </Link>
                                </NavDropdown>
                            ) : null}
                        </Navbar.Collapse>
                    </React.Fragment>
                </Navbar>
            </Nav>
        </div>
    );
};

export default connect<StateProps, DispatchProps, OwnProps, StoreState>(
    (state) => ({
        authorized: state.auth.authorized,
        agencyInfo: state.app.agencyInfo,
        dataDocs: state.invoices.dataDocs,
        unconfirmed: selectGroupUnconfirmed(state),
    }),
    { getUnconfirmedSeances },
)(TopMenu);
